import React, { useEffect, useState } from "react";
import Wheel from "@uiw/react-color-wheel";
import { rgbaToHsva } from "@uiw/color-convert";

const RGBColorPicker = ({ color, setColor }) => {
  const [timeOut, setTimeOut] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Wheel
        width={
          width < 380
            ? 135 + width - 380
            : width < 480
            ? 135 + width - 380
            : 250
        }
        height={
          width < 380
            ? 135 + width - 380
            : width < 480
            ? 135 + width - 380
            : 250
        }
        color={rgbaToHsva(color)}
        onChange={(color) => {
          if (timeOut) {
            clearTimeout(timeOut);
          }
          setTimeOut(
            setTimeout(() => {
              setColor(color.rgb.r, color.rgb.g, color.rgb.b);
            }, 250)
          );
        }}
      />
      {/* <div
        style={{
          width: "100%",
          height: 34,
          marginTop: 20,
          background: hsvaToHex(hsva),
        }}
      ></div> */}
    </div>
  );
};

export default RGBColorPicker;
